/* eslint-disable */

/** unique or primary key constraints on table "argo.material_marriage_status" */
export enum ArgoMaterialMarriageStatusConstraint {
  /** unique or primary key constraint on columns "id" */
  MaterialMarriageStatusPkey = 'material_marriage_status_pkey'
}

export enum ArgoMaterialMarriageStatusEnum {
  /** The marriage is invalid or problematic */
  Bad = 'bad',
  /** The marriage is valid and in good standing */
  Good = 'good',
  /** The marriage has been removed or undone */
  Removed = 'removed'
}

/** select columns of table "argo.material_marriage_status" */
export enum ArgoMaterialMarriageStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

/** update columns of table "argo.material_marriage_status" */
export enum ArgoMaterialMarriageStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id'
}

